<template>
  <div id="post-consent-ui">
    <a
      on="tap:consent-element.prompt();"
      href="#"
      class="manage-cookies"
      loading="lazy"
      @click="$_oneTrust_toggleCookiePreferencesPopup"
    >
      Manage Cookies
    </a>
  </div>
</template>

<script>
export default {
  name: 'FooterManageCookies'
}
</script>

<style lang="scss" scoped>
.manage-cookies {
  color: $c--main;
  cursor: pointer;
  font-size: 12px;
}
</style>
